import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SuppliesLogMaterialItem from './item';

export default class SuppliesLogMaterials extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    const total = this.props.materials.reduce((acc, cur) => cur.subtotal ? acc + cur.subtotal : acc, 0);
    const disabled = this.props.disabled;
    const finFieldsVisible = this.props.financialFieldsVisible;
    const finFieldsDisabled = this.props.financialFieldsDisabled || disabled;

    return (
      <div>
        <div className="row">
          <div className={finFieldsVisible ? "col col-lg-5 col-md-4 col-sm-4" : "col col-9"}>
            <label><b>Name</b></label>
          </div>
          <div className="col col-lg-2 col-md-3 col-sm-3">
            <label><b>Quantity</b></label>
          </div>
          {finFieldsVisible && <div className="col col-2">
            <label><b>Price</b></label>
          </div>}
          {finFieldsVisible && <div className="col col-2">
            <label><b>Subtotal</b></label>
          </div>}
        </div>
        {
          this.props.materials.map((material, index) => (
            <SuppliesLogMaterialItem
              key={material.id}
              isRemovable={this.props.materials.length !== (index + 1)}
              material={material}
              onChange={(field, value) => this.props.onChange(index, field, value)}
              vendorId={this.props.vendorId}
              financialFieldsVisible={finFieldsVisible}
              financialFieldsDisabled={finFieldsDisabled}
              disabled={disabled}
            />
          ))
        }
        <div className="row">
          <div className="col col-12">
            &nbsp;{finFieldsVisible && <label className="pull-right">
              <b>Supplies Total: </b>
              {`$${total.toFixed(2)}`}
            </label>}
          </div>
        </div>
      </div>
    );
  }
}

SuppliesLogMaterials.propTypes = {
  materials: PropTypes.array,
  vendorId: PropTypes.number,
  onChange: PropTypes.func,
  financialFieldsVisible: PropTypes.bool,
  financialFieldsDisabled: PropTypes.bool,
  disabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/common/SuppliesLogMaterials/index.js